import { render, staticRenderFns } from "./telephone-action-area.vue?vue&type=template&id=158b86f0&scoped=true"
import script from "./telephone-action-area.vue?vue&type=script&lang=ts"
export * from "./telephone-action-area.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158b86f0",
  null
  
)

export default component.exports